import { render } from "./ObjSetTableRow.vue?vue&type=template&id=3e9d3a4a"
import script from "./ObjSetTableRow.vue?vue&type=script&lang=js"
export * from "./ObjSetTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__